/* unplugin-vue-components disabled */import { render } from "./Subordinate.vue?vue&type=template&id=b2f89f6c&scoped=true"
import script from "./Subordinate.vue?vue&type=script&lang=js"
export * from "./Subordinate.vue?vue&type=script&lang=js"

import "./Subordinate.vue?vue&type=style&index=0&id=b2f89f6c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f89f6c"]])

export default __exports__